var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data.tax_Exempt)?_c('span',[_c('i',{staticClass:"fa fa-check"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }